export enum GtmEvents {
  noServiceOffered = 'no_service_offered',
  viewItem = 'view_item',
  addShippingInfo = 'add_shipping_info',
  addToCart = 'add_to_cart',
  beginCheckout = 'begin_checkout',
  purchase = 'purchase'
}
